import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useAuth } from 'providers/AuthenticationProvider';
import { Dialog } from 'primereact/dialog';
import { ProgressSpinner } from 'primereact/progressspinner';
import BaseUrl from '../constant/baseUrl';

export default function XacThuc() {
    //! state
    const location = useLocation();
    const search = new URLSearchParams(location.search);
    const { login } = useAuth();

    // !function
    const code = search.get('code');

    //! useEffect
    useEffect(() => {
        if (code) {
            login({
                code,
                redirect_uri: location?.pathname
            });
        }
        // else {
        //     window.location.href = BaseUrl.Login;
        // }
    }, [code]);
    return <></>;
}
